/* We can disable import/no-cycle here because we know that
  api only depends on the User module. */
// eslint-disable-next-line import/no-cycle
import api from '@/api';

const localState = {
  configuration: {},
  links: {
    atlanticSalmon: 'https://www.maine.gov/dacf/mfs/rules_regs/fons/notices/wildlife.salmon.html',
    canadaLynx: 'https://www.maine.gov/dacf/mfs/rules_regs/fons/notices/wildlife.lynx.html',
    mfsHome: 'https://www.maine.gov/dacf/mfs/index.shtml',
    mfsContactUs: 'https://www.maine.gov/dacf/mfs/contact_us.html',
    mfsEthics: 'https://www.maine.gov/sos/cec/rules/02/333/333c100.doc',
    lupc: 'https://www.maine.gov/dacf/lupc/about/contact.shtml',
    mdifw: 'https://www.maine.gov/ifw/about/contact/department-directory.html',
    operationsPermit: 'https://www.maine.gov/dacf/mfs/rules_regs/chap_27.html#fop',
    chapter27Rules: 'https://www.maine.gov/dacf/mfs/rules_regs/chap_27.html',
    chapter26Rules: 'https://www.maine.gov/dacf/mfs/publications/rules_and_regs/chap_26_rules.pdf',
    chapter25Rules: 'https://www.maine.gov/dacf/mfs/publications/rules_and_regs/chap_25_rules.pdf',
    chapter20Rules: 'https://www.maine.gov/dacf/mfs/publications/rules_and_regs/chap_20_rules_05012014.pdf',
    chapter21Rules: 'https://www.maine.gov/dacf/mfs/publications/rules_and_regs/chap_21_rules_effective_01012016.pdf',
    chapter21Section7: 'https://www.maine.gov/dacf/mfs/publications/rules_and_regs/chap_21_rules_effective_01012016.pdf#page=8',
    chapter21Section8: 'https://www.maine.gov/dacf/mfs/publications/rules_and_regs/chap_21_rules_effective_01012016.pdf#page=10',
    chapter21Section11: 'https://www.maine.gov/dacf/mfs/publications/rules_and_regs/chap_21_rules_effective_01012016.pdf#Section_11',
    statute12: 'https://legislature.maine.gov/statutes/12/title12sec8885.html',
    licensedForesterSearch: 'https://www.pfr.maine.gov/ALMSOnline/ALMSQuery/SearchIndividual.aspx',
    title32Chapter76ForesterLicensing: 'https://www.mainelegislature.org/legis/statutes/32/title32ch76sec0.html',
    nrpaChapter305: 'https://www.maine.gov/sos/cec/rules/06/096/096c305.doc',
    roadPermit: 'https://www.maine.gov/dacf/mfs/publications/rules_and_regs/chap_27_road_permit_app_fillable.pdf',
    mfsPublications: 'https://www.maine.gov/dacf/mfs/publications/',
    silvicultural: 'https://www.maine.gov/dacf/mfs/publications/annual_reports.html#silvi',
    stumpagePriceReport: 'https://www.maine.gov/dacf/mfs/publications/annual_reports.html#stumpage',
    currentRegulations: 'https://www.maine.gov/dacf/mfs/rules_and_regulations.html',
    districtForesters: 'https://www.maine.gov/dacf/mfs/policy_management/district_foresters.html',
    soilWaterGuidelines: 'https://www.maine.gov/dacf/php/ag_compliance/docs/fons-ag-field-forest-clearing-policy.pdf',
    farmPondsRegulations: 'https://www.maine.gov/dacf/php/ag_compliance/docs/fons-agricultural-expansion-exemption.pdf',
  },  
  loaded: false,
  loading: false,
  waterFeatureTypeId: 3,
};

const actions = {
  async getConfiguration({ commit, state }) {
    if (state.loaded) return;
    commit('SET_LOADING', true);
    await api.get('/configuration').then((response) => {
      commit('SET_CONFIGURATION', response.data);
      commit('SET_LOADING', false);
      commit('LOADED');
    }).catch(() => {
      commit('SET_LOADING', false);
    });
  },
  unload({ commit }) {
    commit('SET_CONFIGURATION', {});
  },
};

const mutations = {
  SET_CONFIGURATION(state, configuration) {
    state.configuration = configuration;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  LOADED(state) {
    state.loaded = true;
  },
};

const getters = {
  testEnvironment(state) {
    if (state.loaded) return ['local', 'qa', 'uat'].includes(state.configuration.environment);
    return false;
  },
};

export default {
  actions,
  getters,
  mutations,
  state: localState,
  namespaced: true,
};
